
const defaultState = {
	isLoading: true
}
export default {
	namespaced: true,
	state: defaultState,
	getters: {
		getIsLoading (state) {
			return state.isLoading
		}
	},
	mutations: {
		showLoading	(state) {
			state.isLoading = true
		},
		hideLoading (state) {
			state.isLoading = false
		}
	},
	actions: {
		doshowLoading (store) {
			store.commit('showLoading')
		},
		dohideLoading (store) {
			store.commit('hideLoading')
		}
	}
}
